import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import fastDeepEqual from 'fast-deep-equal';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { USER_INPUT_DEBOUNCE_TIME } from '../../../../../../aumico-lib-core-fe/src/lib';
import { IAnnualReportTemplateSettings } from '../../../interfaces/annual-report-template-settings.interface';

@UntilDestroy()
@Component({
    selector: 'aumico-ar-template-settings-page',
    templateUrl: 'ar-template-settings.page.html',
    styleUrls: ['ar-template-settings.page.scss'],
})
export class ArTemplateSettingsPageComponent {
    public formGroup: UntypedFormGroup | undefined;
    private arTemplateSettingsToBeSaved: IAnnualReportTemplateSettings | undefined;

    @Input() arTemplateSettings: IAnnualReportTemplateSettings | undefined;

    @Output() settingsChanged: EventEmitter<IAnnualReportTemplateSettings> =
        new EventEmitter<IAnnualReportTemplateSettings>();

    constructor() {
        this.initializeForm();
    }

    ngOnInit(): void {
        this.monitorFormChanges();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['arTemplateSettings'] != null && this.arTemplateSettings != null) {
            this.handleEditArTemplateSettings();
        }
    }

    private initializeForm(): void {
        this.formGroup = new UntypedFormGroup({
            uncoveredShortfall: new UntypedFormControl(false),
            showShareholderInfo: new UntypedFormControl(false),
        });
    }

    private monitorFormChanges(): void {
        if (this.formGroup == null) {
            throw new Error('Form group is undefined.');
        }
        this.formGroup.valueChanges
            .pipe(
                debounceTime(USER_INPUT_DEBOUNCE_TIME),
                distinctUntilChanged((previousFormChanges, currentFormChanges) =>
                    fastDeepEqual(previousFormChanges, currentFormChanges),
                ),
                untilDestroyed(this),
            )
            .subscribe(() => this.handleFormChanges());
    }

    private handleFormChanges(): void {
        const uncoveredShortfall = this.formGroup?.get('uncoveredShortfall')?.value;
        const showShareholderInfo = this.formGroup?.get('showShareholderInfo')?.value;

        this.arTemplateSettingsToBeSaved = {
            uncoveredShortfall,
            showShareholderInfo,
        };

        this.settingsChanged.emit(this.arTemplateSettingsToBeSaved);
    }

    private handleEditArTemplateSettings(): void {
        this.formGroup?.controls['uncoveredShortfall'].setValue(this.arTemplateSettings.uncoveredShortfall);
        this.formGroup?.controls['showShareholderInfo'].setValue(this.arTemplateSettings.showShareholderInfo);
    }
}
